module.exports = __webpack_public_path__ + "img/file_plus.1047d00e.svg";